<template>
  <div class="images">
    <div class="content-7">
      <header-detail :lottery-code="isActive || 'hk6'" />
    </div>
    <div class="content-8">
      <div class="content-8__titlebar">
        <div class="content-8__titlebar__left">
          <div class="c8-titlename">
            <span class="c8-titlename__text">六合图库</span>
          </div>
          <div class="c8-menubox">
            <div class="menubar">
              <div class="menubar__itembox">
                <div
                  v-for="(tab, tabIndex) in tabList"
                  :id="`${tabIndex}-tab-point`"
                  :key="`tabIndex-${tabIndex}`"
                  class="menubar__item"
                  :class="[isActive === tab ? 'active':'']"
                  @click="switchTab(tab,tabIndex)"
                >
                  <span class="menubar__item__text">{{ cplist[tab].name }}</span>
                  <div class="menubar__item__lightborder"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="tab" mode="out-in">
        <component
          :is="chooseComponent"
          :key="chooseComponent+'-'+keyNumber"
          :tuku-category="tukuCategory"
          :type="isActive"
          :previous-tab-index="previousTabIndex"
          :current-tab-index="currentTabIndex"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import Hk6Pinyin from '@/components/desktop/pages/images/Hk6Pinyin'
import ImagesList from '@/components/desktop/pages/images/ImagesList'

import HeaderDetail from '@/components/desktop/pages/trend/HeaderDetail'
export default {
  name: 'Images',
  transition: 'layout',
  components: {
    Hk6Pinyin,
    ImagesList,
    HeaderDetail
  },
  data() {
    return {
      isActive: '',
      chooseComponent: '',
      keyNumber: null,
      previousTabIndex: null,
      currentTabIndex: null

    }
  },
  computed: {
    // 要生成的tab
    tabList() {
      return this.$store.state.app.hotLottery
    },
    // 每一個tab的詳細內容
    cplist() {
      return this.$store.state.lottery.cpsDetail
    },
    // 從 store 取圖庫ID列表
    tukuCategory() {
      if (this.$store.state.app.tuku[this.isActive]) {
        return this.$store.state.app.tuku[this.isActive].categoryIDs
      } else {
        console.warn('[warn]: No id, check tuku.categoryIDs')
        return []
      }
    }
  },
  watch: {
    keyNumber(newVal, oldVal) {
      this.previousTabIndex = oldVal
      this.currentTabIndex = newVal
    }
  },
  mounted() {
    const { lotteryCode, action, authorization } = this.$route.query
    this.$store.dispatch('lottery/setDrawParams', { // 將網址上的繪圖參數傳給 store
      action,
      authorization
    })
    // 從 lotteryCode 來決定要顯示哪個圖庫元件
    this.selectTab(this.checkLotteryCode(lotteryCode), this.checkLotteryCodeIndex(lotteryCode))
  },
  methods: {
    selectTab(value, indexname) { // 首次進入執行
      this.changeTabComponent(value, indexname)
    },
    switchTab(value, indexname) { // 點擊 tab 執行
      window.location.href = `/images?lotteryCode=${value}`
      this.changeTabComponent(value, indexname)
    },
    changeTabComponent(value, indexname) {
      this.isActive = value
      switch (value) {
        case 'hk6':
          this.chooseComponent = 'Hk6Pinyin'
          this.keyNumber = indexname
          break
        default:
          this.chooseComponent = 'ImagesList'
          this.keyNumber = indexname
      }
      this.changeTabPosition(this.keyNumber)
    },
    changeTabPosition(index) {
      if (index !== undefined && index >= 0) {
        const element = document.getElementById(`${index}-tab-point`)
        if (element) {
          element.scrollIntoView({
            block: 'nearest', inline: 'nearest'
          })
        }
      }
    },
    checkLotteryCode(lotteryCode) {
      const matchingTab = this.tabList.find(tab => tab === lotteryCode)
      return matchingTab ? lotteryCode : (this.tabList[0] || 'hk6')
    },
    checkLotteryCodeIndex(lotteryCode) {
      return this.tabList.includes(lotteryCode) ? this.tabList.indexOf(lotteryCode) : 0
    }
  }
}
</script>

<style lang="scss" scoped>
.content-8__titlebar {
  overflow-x: auto;
  overflow-y: hidden;
  &__left {
    width: 100%;
  }
}
.c8-titlename {
  flex: none;
}
.c8-menubox {
  flex: 1;
  overflow-x: auto;
  overflow-y: hidden;
  width: 100%;
}
.menubar {
  overflow-x: auto;
  overflow-y: hidden;
  &__itembox {
    width: 100%;
  }
}
.c8-select__search{
flex: none;
}
.justify-between{
  justify-content: space-between;
}
.border-bottom{
    border-bottom: solid 1px #EBEBEB;
}
.font-30{
  font-size: 30px;
}

.content-8__content:nth-child(even){
background-color: #FAFAFA;
}

.six-imgbox{
display: flex;
flex-direction: column;
width: 100%;
  &__title{
  width: 100%;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
  box-sizing: border-box;
  border-bottom: solid 1px #EBEBEB;

    &__right{
      height: 100%;
      display: flex;
      align-items: center;
      &__text{
        margin: 0 8px;
      }
    }
  }
  &__control{
    min-height: 50px;
    width: 100%;
    padding: 0 16px;
    box-sizing: border-box;
    border-bottom: solid 1px #EBEBEB;
    position: relative;
    &__icon{
      position: absolute;
      width: 16px;
      height: 16px;
      right: 16px;
      top: 16px;
      cursor: pointer;
      >img{
        width: 100%;
      }
    }
  }
  &__content{
    padding: 16px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    position: relative;
    .content-1__films{
      border: 0;
    }
    .six-imgbox__img{
      width: 100%;
      text-align: center;
      > img {
        max-width: 100%;
      }
    }
  }
}
</style>
